export default __webpack_public_path__ + "static/media/view.c06c2ef4.svg";